import { useEnum } from "@/api/services/global/enum";
import { Tag, TTagVariant } from "@/components/elements/Tag";
import { EMPTY_STR } from "@/constants/string";
import { green, red, state } from "@/theme/colors";
import { EMatchContractStatus } from "@/types/enum";
import { findLabelByValue } from "@/utils/object";
import { FC, useMemo } from "react";

export type TMatchStatusTagProps = {
  status: string;
  variant?: TTagVariant;
};

export const MatchStatusTag: FC<TMatchStatusTagProps> = ({ status, variant = "bold" }) => {
  const { data: contractStatusOptions } = useEnum("EMatchContractStatus");

  const colorTagProps = useMemo(() => {
    if (status === EMatchContractStatus.TRIAL) {
      return { color: state.warning_1, pointColor: state.warning_1 };
    }
    if (status === EMatchContractStatus.DURING_CONTRACT) {
      return { color: green[85], pointColor: state.success_1 };
    }

    return { color: red[97], pointColor: state.error_1 };
  }, [status]);

  return <Tag variant={variant} title={findLabelByValue(contractStatusOptions, status) || EMPTY_STR.TEXT} {...colorTagProps} />;
};
